<template>
    <div class="uzhnet-button-component">
        <div class="uzhnet-button-container">
            <div class="uzhnet-button-label">{{ label }}</div>
            <svg width="100%" height="200%" viewBox="0 0 357 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M7 2H350L356 8V40L350 46H7L1 40V8L7 2Z" fill="#D81159" fill-opacity="0.1"/>
                <path d="M2 9L9 2H348L355 9" stroke="#D81159" stroke-width="3"/>
                <path d="M355 39L348 46H8L2 39" stroke="#D81159" stroke-width="3"/>
            </svg>
        </div>
    </div>
</template>
<script>
export default {
    name: "UzhnetInput",

    props: {
        label: {
            type: String,
            default: 'Ваш текст...'
        },
    }
}
</script>
<style lang="scss" scoped>
.uzhnet-button-component {
    position: relative;
    height: max-content;
}

.uzhnet-button-container {
    position: relative;
    width: 100vw; /* Розтягує контейнер на всю ширину екрана */
    max-width: 100%; /* Гарантує відсутність обмежень */
    margin: 0;
    height: 100%; /* Висота SVG */
}

.uzhnet-button-label {
    position: absolute;
        top: 0;
    left: 0;
    width: 100%; /* Розтягує input на всю ширину контейнера */
    height: 100%;
    border: none;
    background: transparent;
    font-size: 14px;
    color: #D81159;
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
}

@media screen and (max-width: 360px) {
    .uzhnet-button-label {
        font-size: 14px !important;
    }

}

@media screen and (max-width: 305px) {
    .uzhnet-button-label {
        font-size: 10px !important;
    }

}
</style>
